import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP2MedianNew202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p2_median_new_202602",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 2843,
  clicks: 25,
  adsSpendDollars: 70,
  budgetDollars: 300,
  salesDollars: 284,
  bestEstimateRoas: 4.06,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.23,
  newCustomersAcquired: 1,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
